import { Injectable } from '@angular/core';

export const ATTRIBUTION_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_id',
  'campaign_id',
] as const;

export type AttributionParams = Partial<
  Record<(typeof ATTRIBUTION_KEYS)[number], string>
>;

const STORAGE_KEY = 'attribution_params';

@Injectable({ providedIn: 'root' })
export class AttributionService {
  /** Stores the landing URL's campaign/UTM params unless a set is already stored; a URL with none leaves the stored set alone. */
  capture(search: string): void {
    const query = new URLSearchParams(search);
    const found: AttributionParams = {};
    for (const key of ATTRIBUTION_KEYS) {
      const value = query.get(key);
      if (value) found[key] = value;
    }
    if (Object.keys(found).length === 0) return;

    // Jem's requirement of keeping their first recorded entry rather than overwriting it if they return through another link
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(found));
    } catch {
      // Storage can be unavailable (private mode); attribution is best-effort.
    }
  }

  /** The stored params, with only the keys that have a value. */
  get(): AttributionParams {
    try {
      const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) ?? '{}');
      const result: AttributionParams = {};
      for (const key of ATTRIBUTION_KEYS) {
        if (typeof stored[key] === 'string' && stored[key]) result[key] = stored[key];
      }
      return result;
    } catch {
      return {};
    }
  }
}
